import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { api, inr } from "@/lib/api";

export default function OrderSuccess() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then(({ data }) => setOrder(data)).catch(() => {});
  }, [orderId]);

  return (
    <div className="flex min-h-screen items-center justify-center px-5 pt-[68px] lg:pt-[116px]" data-testid="order-success-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-lg text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#34D8A0]"
        >
          <Check className="h-10 w-10 text-black" strokeWidth={3} />
        </motion.div>

        <h1 className="mt-8 font-display text-4xl font-bold tracking-tight">
          {order?.method === "upi_qr" ? "Payment Submitted" : "Payment Successful"}
        </h1>
        <p className="mt-3 text-black/60">
          {order?.method === "upi_qr"
            ? "Thanks! We're verifying your UPI payment and will confirm your order shortly."
            : "Your recovery stack is on the way. A confirmation has been recorded."}
        </p>

        {order && (
          <div className="mt-8 border border-black/10 bg-white p-6 text-left">
            <div className="flex justify-between border-b border-black/10 pb-3">
              <span className="font-mono text-xs uppercase tracking-overline text-black/40">Order ID</span>
              <span className="font-mono text-sm font-semibold">#{order.id.slice(0, 8)}</span>
            </div>
            <div className="flex justify-between border-b border-black/10 py-3">
              <span className="font-mono text-xs uppercase tracking-overline text-black/40">Amount</span>
              <span className="font-mono text-sm font-semibold">{inr(order.total)}</span>
            </div>
            <div className="flex justify-between border-b border-black/10 py-3">
              <span className="font-mono text-xs uppercase tracking-overline text-black/40">Method</span>
              <span className="font-mono text-sm font-semibold text-[#2F80ED]">
                {order.method === "upi_qr" ? "UPI QR" : order.sandbox ? "Razorpay (Test)" : "Razorpay"}
              </span>
            </div>
            <div className="flex justify-between pt-3">
              <span className="font-mono text-xs uppercase tracking-overline text-black/40">Status</span>
              <span className="font-mono text-sm font-semibold">
                {order.payment_status === "paid"
                  ? "Paid"
                  : order.payment_status === "pending_verification"
                  ? "Under verification"
                  : order.payment_status}
              </span>
            </div>
          </div>
        )}

        <div className="mt-8 flex justify-center gap-3">
          <Link to="/orders" className="rounded-full bg-black px-8 py-3 font-semibold text-white hover:bg-[#2F80ED]" data-testid="view-orders-btn">
            View Orders
          </Link>
          <Link to="/shop" className="rounded-full border border-black/15 px-8 py-3 font-semibold hover:bg-black hover:text-white">
            Keep Shopping
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
